import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@/feature/utils';

import { CommitteeCard } from './components/Card/CommitteeCard';
import { getCommitteePagedOptions } from './model/CommitteeQuery';

export function CommitteeBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getCommitteePagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('committees.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('committees.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('committees.sortedByPublishDate')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={committee => (
        <CommitteeCard
          key={committee.id}
          committee={committee}
          to={`${committee.id}`}
        />
      )}
    />
  );
}
